import { post } from "@insite/client-framework/Services/ApiService";

export interface ExistingOrderFormParamter {
    OrderNumber: string;
    Name: string;
    CompanyName: string;
    Email: string;
    Message: string;
    onSuccess?: () => void;
}

export interface ExistingOrderFormModel  {}

const createExistingOrderForm = "api/v2/email/existingorder";

export async function existingOrderFormService(parameter: ExistingOrderFormParamter) {
    const response = await post<ExistingOrderFormModel>(createExistingOrderForm, parameter);
    return response;
}
